( function () {
	'use strict';

	function startobsservice ( $modal ) {
		function openModal ( event ) {
			$modal.open( {
				'templateUrl'  : '/templates/schedules/start-observation/start-obs-modal.html',
				'controller'   : 'StartObsModal',
				'controllerAs' : 'vm',
				'keyboard'     : false,
				'backdrop'     : 'static',
				'resolve'      : {
					'eventModel' : function () {
						return event;
					}
				}
			} );
		}

		return {
			'openModal' : openModal
		};
	}

	angular
		.module( 'app.schedules' )
		.factory( 'startobsservice', startobsservice );

	startobsservice.$inject = [ '$modal' ];
} )( );
